"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useRating_1 = __importDefault(require("./useRating"));
var Ratings_less_1 = __importDefault(require("./Ratings.less"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var classnames_1 = __importDefault(require("classnames"));
var Ratings = function (_a) {
    var _b, _c;
    var ratingInfo = _a.ratingInfo, className = _a.className;
    var _d = (0, useRating_1.default)(ratingInfo), onLiked = _d.onLiked, onLoved = _d.onLoved, liked = _d.liked, loved = _d.loved;
    var disabled = (0, react_1.useMemo)(function () { return (ratingInfo === null || ratingInfo === void 0 ? void 0 : ratingInfo.type) !== 'Ready'; }, [ratingInfo]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(Ratings_less_1.default['ratings-container'], className) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Ratings_less_1.default['rating-button'], (_b = {}, _b[Ratings_less_1.default['disabled']] = disabled, _b)), onClick: onLiked },
            react_1.default.createElement(react_2.default, { name: liked ? 'thumbs-up' : 'thumbs-up-outline', className: Ratings_less_1.default['icon'] })),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Ratings_less_1.default['rating-button'], (_c = {}, _c[Ratings_less_1.default['disabled']] = disabled, _c)), onClick: onLoved },
            react_1.default.createElement(react_2.default, { name: loved ? 'heart' : 'heart-outline', className: Ratings_less_1.default['icon'] }))));
};
exports.default = Ratings;
